import View from './reports/view'
import Edit from './reports/edit'

export default [
  ...View,
  ...Edit
]
